"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORM_REFRESH_ON_SUBMIT_FAIL = void 0;
// FORM
var FORM_REFRESH_ON_SUBMIT_FAIL = exports.FORM_REFRESH_ON_SUBMIT_FAIL = 'FORM_REFRESH_ON_SUBMIT_FAIL';